import React from 'react';

const ChallengeBadgeCount = ({ value }) => (
  <span className="challenge-badge-count">{value || 0}</span>
);

export default ChallengeBadgeCount;
